import React from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'
import { discCode } from 'src/Common/studentAssessmentEnums'

const DISC_COLOR = { D: '#ef4444', I: '#f59e0b', S: '#10b981', C: '#3b82f6' }

const Section = ({ title, children }) =>
  children ? (
    <div style={{ marginTop: 14 }}>
      <div
        style={{
          fontSize: 12,
          color: '#94a3b8',
          textTransform: 'uppercase',
          letterSpacing: 0.4,
          marginBottom: 4,
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 13, color: '#334155', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>
        {children}
      </div>
    </div>
  ) : null
Section.propTypes = { title: PropTypes.node, children: PropTypes.node }

// Renders an approved DISC PersonalityResult. `result` may be null (not yet available).
const PersonalityResult = ({ result }) => {
  if (!result) {
    return <Empty description="No personality result available." />
  }
  const weights = (result.discWeights || [])
    .map((w) => ({ code: discCode(w.type), percentage: Math.round(Number(w.percentage) || 0) }))
    .filter((w) => w.code)

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 34, fontWeight: 800, color: '#16233f', letterSpacing: 1 }}>
          {result.profileCode || '—'}
        </span>
        {result.name ? (
          <span style={{ fontSize: 16, fontWeight: 600, color: '#475569' }}>{result.name}</span>
        ) : null}
      </div>

      {weights.length ? (
        <div
          style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 460 }}
        >
          {weights.map((w) => (
            <div key={w.code} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ width: 22, fontWeight: 700, color: DISC_COLOR[w.code] || '#64748b' }}>
                {w.code}
              </span>
              <div
                style={{
                  flex: 1,
                  background: '#eef2f7',
                  borderRadius: 999,
                  height: 10,
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    width: `${w.percentage}%`,
                    height: '100%',
                    background: DISC_COLOR[w.code] || '#64748b',
                    borderRadius: 999,
                  }}
                />
              </div>
              <span style={{ width: 42, textAlign: 'right', fontSize: 12, color: '#64748b' }}>
                {w.percentage}%
              </span>
            </div>
          ))}
        </div>
      ) : null}

      <Section title="Summary">{result.summary}</Section>
      <Section title="Guidance">{result.studentGuidanceDescription}</Section>
      <Section title="Strengths">{result.strengths}</Section>
      <Section title="Development areas">{result.developmentAreas}</Section>
      <Section title="Relationships">{result.relationshipInsights}</Section>
      <Section title="Professional">{result.professionalInsights}</Section>
      <Section title="Personal development">{result.personalDevelopmentInsights}</Section>
    </div>
  )
}

PersonalityResult.propTypes = { result: PropTypes.object }

export default PersonalityResult
